import * as React from "react";
import styled, { css, keyframes } from "styled-components";
import theme from "src/theme";

const fadeIn = keyframes`
  0%{
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeInAnimation = () =>
  css`
    ${fadeIn};
  `;

const CloseBtn = styled.button`
  position: absolute;
  z-index: 1;
  top: 30px;
  right: 30px;
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    svg .cross {
      transition: fill 0.2s ease-in;
      fill: ${theme.color.red};
    }
  }
`;

const ThumbnailContainer = styled.div<{ currentLayer: string }>`
  display: grid;
  width: 100%;
  margin-top: 20px;
`;

const Thumbnail = styled.img<{ width: string; height: string }>`
  width: ${p => p.width || "100%"};
  height: ${p => p.height || "auto"};
  margin: auto;
`;

const Article = styled.div<{ show: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 30px;
  opacity: 0;
  animation: ${p => (p.show ? fadeInAnimation : "none")};
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
`;

const Inner = styled.div`
  position: relative;
  width: auto;
  min-width: 50%;
  min-height: 50%;
  margin: auto;
  background-color: ${theme.color.white};
  transition: all 0.2s ease-in;
`;

const Heading = styled.h1`
  font-family: ${theme.font.bold};
  font-weight: bold;
  font-size: 46px;
  line-height: 1;
  text-transform: uppercase;
  color: ${theme.color.red};
  margin-right: 60px;
`;

const Container = styled.div`
  position: fixed;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  display: flex;
  background-color: rgba(51, 51, 51, 0.5);
`;

interface LightboxProps {
  image: string;
  title: string;
  width: string;
  height: string;
  className?: string;
  show: boolean;
  onClose: any;
}

class Lightbox extends React.Component<LightboxProps> {
  constructor(props: LightboxProps) {
    super(props);
  }
  render() {
    const {
      className,
      image,
      title,
      width,
      height,
      show,
      onClose
    } = this.props;

    if (!show) {
      return null;
    }

    return (
      <Container className={className}>
        <Inner>
          <Article show={!!image}>
            <CloseBtn onClick={onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path fill="none" d="M0 0h24v24H0V0z" />
                <path
                  className="cross"
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                />
              </svg>
            </CloseBtn>
            <Heading>{title}</Heading>
            <ThumbnailContainer>
              <Thumbnail width={width} height={height} src={image} />
            </ThumbnailContainer>
          </Article>
        </Inner>
      </Container>
    );
  }
}

export default Lightbox;



// WEBPACK FOOTER //
// ./src/modules/Lightbox.tsx